<div class="container welcome-container">
  <div class="heading">Welcome to Evaltrix</div>
  <div class="sub-heading">Welcome! You have been registered successfully. Provide us further information to get
    started.</div>

  <div class="form-content-wrapper">
    <div class="label"> Add Role </div>
    <mat-form-field class="example-chip-list" appearance="outline">
      <mat-chip-grid #chipList aria-label="role selection">
        <mat-chip-row *ngFor="let role of roles" [removable]="removable" (removed)="remove(role)">
          {{role}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input placeholder="Add a role..." #roleInput matChipInputAddOnBlur="false" [formControl]="roleCtrl"
          [matAutocomplete]="RoleAuto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)" (blur)="addOnBlur($event)">
      </mat-chip-grid>
      <mat-autocomplete #RoleAuto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let role of filteredRoles | async" [value]="role">
          {{role}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div class="label"> How many technical roles do you plan to screen and hire for the next 12 months? </div>
    <form class="welcome-form">
      <mat-form-field class="auto-complete" appearance="outline">
        <input type="number" placeholder="Enter technical roles" aria-label="Number" matInput
          [(ngModel)]="noOfTechinicalRoles" name="noOfTechinicalRoles">
      </mat-form-field>

      <div class="question-text">Which of the following have you done in the past?</div>
      <div *ngFor="let option of questionFirst.options; let i = index">
        <mat-checkbox aria-colcount="red" color="primary" [(ngModel)]="option.checked" class="example-margin"
          name="option{{i}}">{{option.name}}
        </mat-checkbox>
      </div>

      <div class="question-text radio-question">{{questionSecond.name}}</div>
      <div class="radio-button-group">
        <mat-radio-group (change)="radioButtonChangEvent($event)">
          <mat-radio-button color="primary" *ngFor="let option of questionSecond.options" [value]="option.name">
            {{option.name}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="btn-save-container">
        <button type="submit" class="btn-save" mat-flat-button color="primary" (click)="submitProfile()">Save</button>
      </div>
    </form>
  </div>
</div>